<div
  class="modal dy-modal"
  tabindex="-1"
  role="dialog"
  aria-hidden="true"
  style="display: block; top: 90px"
  [ngClass]="{ active: active }"
>
  <div
    [ngClass]="
      childInstance.modalClass
        ? childInstance.modalClass
        : 'modal-dialog modal-lg'
    "
    role="document"
  >
    <div class="modal-content">
      <div class="modal-header" style="color: white; padding: 0.5rem 1rem">
        <div style="display: flex">
          <h5 *ngIf="childInstance.mode === 'add'" class="modal-title">
            {{ "new" | translate }} &nbsp;
          </h5>
          <h5 class="modal-title">{{ title | translate }}</h5>
          <h5
            *ngIf="
              childInstance.mode === 'edit' || childInstance.mode === 'view'
            "
            class="modal-title"
          >
            [{{ childInstance.entity.code | translate }}]
          </h5>
        </div>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          (click)="explorerService.closeModal(this)"
          style="color: #fff"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <kl-alert
          [show]="errorShow"
          [message]="errorText"
          [type]="'error'"
          (onClose)="errorShow = false"
        ></kl-alert>
        <ng-content></ng-content>
        <ng-template #templateRef></ng-template>
      </div>
      <div
        class="modal-footer"
        *ngIf="!childInstance?.closeInside && _stateSelector"
      >
        <span *ngIf="modalActions">
          <button
            *ngFor="let modalAction of modalActions"
            type="button"
            class="btn btn-sm"
            [class]="modalAction.btnClass"
            (click)="(modalAction.action)"
          >
            <i [class]="modalAction.btnIcon"></i>
            {{ modalAction.label | translate }}
          </button>
        </span>
        <button
          *ngIf="childInstance?.trigger_type && showSelectButton"
          type="button"
          class="btn btn-bluefish btn-sm"
          data-dismiss="modal"
          (click)="select(false)"
        >
          {{ "select_and_continue" | translate }}
        </button>
        <button
          *ngIf="showSelectButton"
          type="button"
          class="btn btn-greenish btn-sm"
          data-dismiss="modal"
          (click)="select(true)"
        >
          {{ "select" | translate }}
        </button>
        <button
          type="button"
          class="btn btn-default btn-sm"
          data-dismiss="modal"
          (click)="explorerService.closeModal(this)"
        >
          {{ "close" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
